import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Card, CardProps } from '@qga/roo-ui/components';

const StyledCard = styled(Card)`
  opacity: 0.6;
  overflow: hidden;
  box-shadow: ${themeGet('shadows.hard')};
  background-color: ${themeGet('colors.snow')};
`;

interface Props extends CardProps {
  children: React.ReactNode;
}

const SkeletonCard = ({ children, ...rest }: Props) => (
  <StyledCard data-testid="skeleton" {...rest}>
    {children}
  </StyledCard>
);

export default SkeletonCard;
